export const changeHeaderTheme = (themeColor) => {
	var logo = document.getElementById('main-logo');
	var header = document.getElementById('header-container');
	var search = document.getElementById('search-icon');
	var threeButton = document.getElementById('header-drop-open');

	switch (themeColor) {
		case 'white':
			logo.src = '/assets/logos/blueconnect.png';
			search.src = '/assets/icons/searchBlue.svg';
			header.style.background = 'white';
			header.style.color = '#004b80';
			threeButton.classList.add('blue-button');
			break;
		case 'transparent':
			logo.src = '/assets/logos/gdp-logo.png';
			search.src = '/assets/icons/searchWhite.svg';
			header.style.background = 'transparent';
			header.style.color = '#ffffff';
			threeButton.classList.remove('blue-button');
			break;
		case 'transparent-blue':
			logo.src = '/assets/logos/blueconnect.png';
			search.src = '/assets/icons/searchBlue.svg';
			header.style.background = 'transparent';
			header.style.color = '#004b80';
			// threeButton.classList.remove('blue-button');
			break;
	}
};



// WEBPACK FOOTER //
// ./utils/changeHeaderTheme.js